// removed by extract-text-webpack-plugin
module.exports = {"input-field":"input-field--2dgBD","disabled":"disabled--2efc4","error":"error--2-Tsf","label-container":"label-container--Ksk2q","label":"label--2ND9R","badge":"badge--1484C","is-active":"is-active--qCCSV","error-message":"error-message--2cYSY"};


//////////////////
// WEBPACK FOOTER
// ./client/components/input-field/input-field.scss
// module id = 185
// module chunks = 0